import React from 'react'
import {BrowserRouter,Switch,Route} from 'react-router-dom'

import './App.css';
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import Landing from './Components/Pages/Landing/Landing';
import RegistrationForm from './Components/Pages/Registration Form/RegistrationForm';

import HiringAndSelection from './Components/Pages/How We Help/HiringAndSelection';
import TrainingAndDevelopment from './Components/Pages/How We Help/TrainingAndDevelopment';
import LeadershipIdentification from './Components/Pages/How We Help/LeadershipIdentification';
import TeamBuildingAndAnalytics from './Components/Pages/How We Help/TeamBuildingAndAnalytics';
import CultureAndValues from './Components/Pages/How We Help/CultureAndValues';

import CognitiveQuotient from './Components/Pages/Solutions/CognitiveQuotient'
import EnglishProficiency from './Components/Pages/Solutions/EnglishProficiency'
import LeadershipProfile from './Components/Pages/Solutions/LeadershipProfile'
import WorkStylePerformance from './Components/Pages/Solutions/WorkStylePerformance'
import WorkValueAttribute from './Components/Pages/Solutions/WorkValueAttitude'
import Pratibimb from './Components/Pages/Solutions/Pratibimb'
import CommunicationSkills from './Components/Pages/Solutions/CommunicationSkills'

import TripleI from './Components/Pages/Our Approach/TripleI'

import Partners from './Components/Pages/Partners/Partners'
import BecomePartner from './Components/Pages/Partners/BecomePartner'
import GetSLCertified from './Components/Pages/Partners/GetSLCertified'

import OurFounder from './Components/Pages/About/OurFounder'
import ScientificAdvisors from './Components/Pages/About/ScientificAdvisors'
import MissionVisionValues from './Components/Pages/About/MissionVisionValues'
import FAQs from './Components/Pages/About/FAQs'
import Careers from './Components/Pages/About/Careers'
import Contact from './Components/Pages/About/Contact'

import TestsLanding from './Components/Pages/Tests Section/Main/TestsLanding';
import AptitudeTest from './Components/Pages/Tests Section/Aptitude/AptitudeTest';
import PersonalityTest from './Components/Pages/Tests Section/Personality/PersonalityTest';
import EQTest from './Components/Pages/Tests Section/EQ/EQTest';
import Signin from './Components/Pages/Tests Section/Login/Signin';


import AdminDashboard from './Components/Admin Panel/Dashboard/AdminDashboard';
import AdminLogin from './Components/Admin Panel/Login/Login';
import Registerations from './Components/Admin Panel/Registerations/Registerations';
import Gallery from './Components/Gallery/Gallery';


import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import UnderConstruction from './UnderConstruction';



function App() {
  return (
    // <UnderConstruction/>
    <div className='App'>
      <BrowserRouter>
        <Header/>

      <div style={{paddingTop:'15vh'}}>
        <Switch>
          <Route exact path="/">
            <Landing/>
          </Route>

          {/*How We Help */}
          <Route path="/hiring-and-selection">
            <HiringAndSelection/>
          </Route>

          <Route path="/training-and-development">
            <TrainingAndDevelopment />
          </Route>

          <Route path="/leadership-identification">
            <LeadershipIdentification />
          </Route>

          <Route path="/team-building">
            <TeamBuildingAndAnalytics />
          </Route>

          <Route path="/culture-and-values">
            <CultureAndValues />
          </Route>


          {/*Solutions */}
          
          <Route path="/pratibimb">
            <Pratibimb/>
          </Route>

          <Route path="/work-value-attitude">
            <WorkValueAttribute/>
          </Route> 

          <Route path="/work-style-performance">
            <WorkStylePerformance/>
          </Route>

          <Route path="/cognitive-quotient">
            <CognitiveQuotient/>
          </Route>

          <Route path="/english-proficiency">
            <EnglishProficiency/>
          </Route>

          <Route path="/communication-skills">
            <CommunicationSkills/>
          </Route>

          <Route path="/leadership-profile">
            <LeadershipProfile/>
          </Route>


          {/*Our Approach */}
          
          <Route path="/triple-i">
            <TripleI/>
          </Route>


          {/*Partners */}

          <Route path="/partners">
            <Partners/>
          </Route>

          <Route path="/become-a-partner">
            <BecomePartner/>
          </Route> 

          <Route path="/certification">
            <GetSLCertified/>
          </Route>

  
          {/*About */}

          <Route path="/founder">
            <OurFounder/>
          </Route>

          <Route path="/scientific-advisors">
            <ScientificAdvisors/>
          </Route> 

          <Route path="/mission-vision-values">
            <MissionVisionValues/>
          </Route>

          <Route path="/faqs">
            <FAQs/>
          </Route>

          <Route path="/careers">
            <Careers/>
          </Route>

          <Route path="/contact">
            <Contact/>
          </Route>


          {/* Tests Section */}

          <Route path="/tests-login">
            <Signin />
          </Route>

          <Route path="/tests">
            <TestsLanding />
          </Route>

          <Route path="/aptitude-test">
            <AptitudeTest />
          </Route>

          <Route path="/personality-test">
            <PersonalityTest />
          </Route>

          <Route path="/eq-test">
            <EQTest />
          </Route>

          {/* Components */}

          <Route path="/register">
            <RegistrationForm/>
          </Route>

          <Route path="/admin-login">
            <AdminLogin />
          </Route>

          <Route path="/admin-dashboard">
            <AdminDashboard />
          </Route>


          <Route path="/admin-webinar-responses">
            <Registerations />
          </Route>

          <Route exact path="/gallery">
            <Gallery/>
          </Route>
        </Switch> 
      </div>

        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
